import { gql } from "@apollo/client";

export const GET_CONVERSATIONS = gql`
  query GetConversations($params: GetConversationsInput!) {
    conversations(params: $params) {
      total
      page
      limit
      items {
        id
        remittanceItemId
        referenceId
        categoryKey
        categoryTypeKey
        invoiceNumber
        checkNumber
        purchaserKey
        purchaserName
        createdAt
        updatedAt
        lastMessage {
          messageId
          messagePreview
          attachmentCount
          sender {
            email
            firstName
            lastName
            fullName
            avatar
            isDeleted
          }
        }
      }
    }
  }
`;
